import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PwaService {
  private platformId = inject(PLATFORM_ID);
  installPrompt$ = new ReplaySubject<{ prompt: () => void } | null>(1);

  constructor() {
    if (isPlatformServer(this.platformId)) return;
    window.addEventListener('beforeinstallprompt', (event: Event & { prompt: () => void }) => {
      event.preventDefault();
      console.log('beforeinstallprompt');
      this.installPrompt$.next(event);
    });
  }
}
